import { UIComponentViewImpl } from '../../../../toolkit/uicomponentview';
import { UIDataModel, UIComponentState } from '../../../../toolkit/uicomponent';
import { ToneOptionCardComponentProps } from './toneoptioncardcomponent';
import * as React from 'react';
import { ToneOptionCardCSSStyle } from './toneoptioncardcss';

export class ToneOptionCardViewImpl extends UIComponentViewImpl<UIDataModel>
{
    draw(props: ToneOptionCardComponentProps, state: UIComponentState, cssStyle: ToneOptionCardCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <div style={cssStyle.getWrapperCSSStyle()}>
                <div style={cssStyle.getIconDivCSSStyle()}>
                <img  src={this.getContext().getResources().getImage(props.iconName)} width="20px" height="20px"/>
                </div>
                <label style={cssStyle.getTitleLabelCSSStyle()}>
                    {props.title}
                </label>
            </div> 
        );
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/toneoption/toneoptioncard/toneoptioncardview.tsx